import { useState, useEffect } from 'react';

export type Device = 'laptop' | 'desktop';

export function useMediaQuery(): Device {
  const [device, setDevice] = useState('laptop' as Device);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1272px)');
    const device: Device = mediaQuery.matches ? 'laptop' : 'desktop';
    setDevice(device);

    const listener = (event: MediaQueryListEvent) => {
      if (event.matches) {
        setDevice('laptop');
      } else {
        setDevice('desktop');
      }
    };

    mediaQuery.addListener(listener);

    return () => mediaQuery.removeListener(listener);
  }, []);

  return device;
}
